import React, { useState, Suspense, useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Link,useLocation, Navigate } from "react-router-dom";

import Loading from "./screens/Loading";
import Home from "./screens/Home";
import Header from "./components/Header";
import SideBar from "./components/SideBar";
import Login from "./screens/Login";
import Staff from './screens/User/Staff'
import Joinnow from "./screens/Joinnow";
import { useSelector, useDispatch } from "react-redux";

import ForgotPassword from "./screens/ForgotPassword";
import VerifyOtp from "./screens/VerifyOtp";
import ResetPassword from "./screens/ResetPassword";

import Demo from "./screens/Demo";
import LoadingIndicator from "./components/Spinner";
import CreateUser from "./screens/User/CreateUser";
import UserList from './screens/User/UserList';
import UserBlockList from './screens/User/UserBlockList'
import ActionList from "./screens/User/ActionList";
import AccessList from "./screens/User/AccessList";
import Bets from "./screens/Bets";
import VoidBets from "./screens/Bets/VoidBets";
import CancelledBets from "./screens/Bets/CancelledBets";
import ResettledBets from "./screens/Bets/ResettledBets";
import BetsResult from "./screens/Bets/Result";
import Results from "./screens/Results";
import DefineResults from "./screens/DefineResults";
import XmlResults from "./screens/XmlResults";
import { Actions } from "./redux/Actions/Actions";
import Transfer from './screens/Transfer'
import TransferDetail from './screens/Transfer/TransferDetail'
import TransferSummary from './screens/Transfer/TransferSummary'
import Loyalty from "./screens/Loyalty";

import TransactionsDetail from './screens/Transactions/TransactionsDetail'
import TransactionsSummary from './screens/Transactions/TransactionsSummary'

import LiveBettingDetails from "./screens/Bets/LiveBettingDetails";
import LiveBettingReport from "./screens/Bets/LiveBettingReport";

import ResultsDetail from "./screens/Results/ResultsDetail";
import ResultsSummary from "./screens/Results/ResultsSummary";

import SportsLiability from './screens/SportsLiability'
import UserDetails from './screens/User/UserList/UserDetails'
import PromoList from './screens/PromoList'
import Banner from "./screens/Banner";
import Bonus from './screens/Bouns'
import BulkBouns from './screens/BulkBouns'

import Provider from './screens/Casino/Provider';
import Menu from './screens/Casino/Menu'
import FeatureGames from './screens/Casino/FeatureGames';
import CoinPackage from './screens/Casino/CoinPackage';
import Games from './screens/Casino/Games';
import Promo from './screens/Casino/Promo';
import Redemption from './screens/Casino/Redemption'
import MarketingPopup from './screens/MarketingPopup';
import RedemptionClaims from "./screens/Casino/RedemptionClaims";
import RedemptionDetails from "./screens/Casino/RedemptionClaims/redemDetails";
import Payments from "./screens/Payments";
import Campaign from "./screens/Campaign";
import Coupon from './screens/Coupon'
import CouponUser from "./screens/Coupon/CouponUser";
import CampaignUser from "./screens/Campaign/CampaignUser"
import TrackingCouponCampaign from './screens/TrackingCouponCampaign'
import CoinTransaction from "./screens/CoinTransaction";
import RedemTransaction from './screens/RedemTransaction'
import { axiosInstance } from "./Utility/axiosInstances";
import ReferFriendDailyClaim from "./screens/Casino/ReferFriendDailyClaim";
import OfferPost from "./OfferPost";
import Category from "./screens/Casino/Category";
import MailInList from "./screens/MailInList";
import CasinoSubscribers from "./screens/CasinoSubscribers";
import SpinsagaGames from "./screens/Casino/SpinsagaGames";
import WheelofFortune from "./screens/WheelofFortune";
import MonthlyPromotions from "./screens/MontlyPromotions";
import PromotionConfig from "./screens/PromotionConfig";
import PromotionNavigation from "./screens/PromotionsNavigation.js";
import PromoCampaign from "./screens/PromoCampaign";
import Leaderboard from "./screens/Leaderboard";
import Affiliate from "./screens/Affiliate";
import UtmReport from "./screens/UtmReport";
import KYCList from "./screens/KYCList";
import BlockDomain from "./screens/User/BlockDomain";
import HappyHour from "./screens/HappyHour";
import PopupOffers from "./screens/PopupOffers";
import Lottery from "./screens/Lottery";
// import { useNavigate } from "react-router-dom";

const App = () => {
  const [userIsAuthenticated, setUserIsAuthenticated] = useState(false);
  const state = useSelector((state) => state);
  const dispatch = useDispatch()
  const { auth, sidebar } = state;
  let validation = true;
  // let navigate = useNavigate();

  useEffect(() => {
    getLoginUser()
  }, []);
  function getLoginUser() {
    const Session = JSON.parse(sessionStorage.getItem("session"));
    const User = JSON.parse(sessionStorage.getItem("user"));
    if (Session != null) {
      dispatch({
        type: Actions.LOGIN,
        data: { user: User },
      });
    }
  }

  // axiosInstance.interceptors.request.use((config) => {
  //   // config.headers["SessonId"] = IsLoginData.sessionId;
  //   config.headers["SessonId"] = localStorage.getItem("session");
  //   return config;
  // });

  
 
  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      console.log("error", error);
      if (error?.response?.status == "401") {
        localStorage.clear();
        window.alert(
          "You are currently logged in on another device. Please login again to continue.  You will be logged out of your other device."
        );
        dispatch({
          type: Actions.LOGOUT,
        });
        sessionStorage.clear();
        // navigate("/login");
        window.location.reload();
      }
      return error;
    }
  );
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* {auth.isAuthenticated && validation ? <SideBar /> : null} */}
        <div
        // className={
        //   sidebar.isSideBarOpen ? "main-content-expanded" : "main-content"
        // }
        >
          <Routes>
            <Route
              exact
              path="/Demo/userId=:id/password=:pass"
              element={<Demo />}
            />
            <Route exact path="/Spinner" element={<LoadingIndicator />} />
         
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/verify-otp" element={<VerifyOtp />} />
            {!auth.isAuthenticated && (
            <Route path="*" element={<Navigate to="/login" replace />} />
            )}
             {auth.isAuthenticated && (
            <Route path="*" element={<Navigate to="/Home" replace />} />
            )}
                       
            
            <Route exact path="/Join-Now" element={<Joinnow />} />
            <Route exact path="/UserList" element={<RequireAuth><UserList /></RequireAuth>} />
            <Route exact path="/ActionList" element={<RequireAuth><ActionList /></RequireAuth>} />
            <Route exact path="/AccessList" element={<RequireAuth><AccessList /></RequireAuth>} />
            <Route exact path="/UserBlockList" element={<RequireAuth><UserBlockList /></RequireAuth>} />
            <Route exact path="/Staff" element={<RequireAuth><Staff /></RequireAuth>} />
            <Route exact path="/Transfer" element={<RequireAuth><Transfer /></RequireAuth>} />


            <Route exact path="/Reset-Password" element={<RequireAuth><ResetPassword /></RequireAuth>} />
            <Route exact path="/ForgotPassword" element={<ForgotPassword />} />

        
            <Route exact path="/Home" element={ <RequireAuth><Home/></RequireAuth>} />
            <Route exact path="/loyalty" element={<RequireAuth><Loyalty /></RequireAuth>} />
            <Route exact path="/PromoList" element={<RequireAuth><PromoList /></RequireAuth>} />

            <Route exact path="/Banner" element={<RequireAuth><Banner /></RequireAuth>} />

            <Route exact path="/MarketingPopup" element={<RequireAuth><MarketingPopup /></RequireAuth>} />

            <Route exact path="/bonus" element={<RequireAuth><Bonus /></RequireAuth>} />
            <Route exact path="/bulkBonus" element={<RequireAuth><BulkBouns /></RequireAuth>} />
            
            

            <Route exact path="/UserDetails/:userId" element={ <RequireAuth><UserDetails/></RequireAuth>} />
            <Route exact path="/Bets" element={<RequireAuth><Bets /></RequireAuth>} />
            <Route exact path="/CancelledBets" element={<RequireAuth><CancelledBets /></RequireAuth>} />
            <Route exact path="/VoidBets" element={<RequireAuth><VoidBets /></RequireAuth>} />
            <Route exact path="/ResettledBets" element={<RequireAuth><ResettledBets /></RequireAuth>} />
            <Route exact path="/BetsResult" element={<RequireAuth><BetsResult /></RequireAuth>} />
            <Route exact path="/Results" element={<RequireAuth><Results /></RequireAuth>} />            
            <Route exact path="/DefineResults" element={<RequireAuth><DefineResults /></RequireAuth>} />
            <Route exact path="/XmlResults" element={<RequireAuth><XmlResults /></RequireAuth>} />
            <Route exact path="/CreateUser" element={<RequireAuth><CreateUser /></RequireAuth>} />
            
            <Route exact path="/TransferSummary" element={<RequireAuth><TransferSummary /></RequireAuth>} />
            <Route exact path="/TransferDetails" element={<RequireAuth><TransferDetail /></RequireAuth>} />

            <Route exact path="/TransactionsDetail" element={<RequireAuth><TransactionsDetail /></RequireAuth>} />
            <Route exact path="/TransactionsSummary" element={<RequireAuth><TransactionsSummary /></RequireAuth>} />


            <Route exact path="/LiveBettingDetails" element={<RequireAuth><LiveBettingDetails /></RequireAuth>} />
            <Route exact path="/LiveBettingReport" element={<RequireAuth><LiveBettingReport /></RequireAuth>} />
           
            <Route exact path="/ResultsDetail" element={<RequireAuth><ResultsDetail /></RequireAuth>} />
            <Route exact path="/ResultsSummary" element={<RequireAuth><ResultsSummary/></RequireAuth>} />
            <Route exact path="/SportsLiability" element={<RequireAuth><SportsLiability/></RequireAuth>} />

            <Route exact path="/provider" element={<RequireAuth><Provider/></RequireAuth>} />
            <Route exact path="/menu" element={<RequireAuth><Menu/></RequireAuth>} />
            <Route exact path="/category" element={<RequireAuth><Category/></RequireAuth>} />
            <Route exact path="/featureGames" element={<RequireAuth><FeatureGames/></RequireAuth>} />
            <Route exact path="/coinPackage" element={<RequireAuth><CoinPackage/></RequireAuth>} />
            <Route exact path="/games" element={<RequireAuth><Games/></RequireAuth>} />
            <Route exact path="/promo" element={<RequireAuth><Promo/></RequireAuth>} />
            <Route exact path="/gift-card" element={<RequireAuth><Redemption/></RequireAuth>} />
            <Route exact path="/redemptionClaims" element={<RequireAuth><RedemptionClaims/></RequireAuth>} />
            <Route exact path="/redemption-details" element={<RequireAuth><RedemptionDetails/></RequireAuth>} />
            <Route exact path="/Payments" element={<RequireAuth><Payments/></RequireAuth>} />
            <Route exact path="/coinTransaction" element={<RequireAuth><CoinTransaction/></RequireAuth>} />
            <Route exact path="/campaign" element={<RequireAuth><Campaign/></RequireAuth>} />
            <Route exact path="/coupon" element={<RequireAuth><Coupon/></RequireAuth>} />
            <Route exact path="/spinsaga-games" element={<RequireAuth><SpinsagaGames/></RequireAuth>} />
           
            <Route exact path="/wheel-of-fortune" element={<RequireAuth><WheelofFortune/></RequireAuth>} />

            <Route exact path="/monthly-promotions" element={<RequireAuth><MonthlyPromotions/></RequireAuth>} />

            <Route exact path="/promotion-config" element={<RequireAuth><PromotionConfig/></RequireAuth>} />
            <Route exact path="/promo-campaigns" element={<RequireAuth><PromoCampaign/></RequireAuth>} />


            <Route exact path="/couponUser" element={<RequireAuth><CouponUser/></RequireAuth>} />
            <Route exact path="/campaignUser" element={<RequireAuth><CampaignUser/></RequireAuth>} />

            <Route exact path="/tracking" element={<RequireAuth><TrackingCouponCampaign/></RequireAuth>} />
            <Route exact path="/redem-transaction" element={<RequireAuth><RedemTransaction/></RequireAuth>} />
            <Route exact path="/config-list" element={<RequireAuth><ReferFriendDailyClaim/></RequireAuth>} />


            <Route exact path="/offer-list" element={<RequireAuth><OfferPost/></RequireAuth>} />
            <Route exact path="/mailIn-list" element={<RequireAuth><MailInList/></RequireAuth>} />
            <Route exact path="/casino-subscribers" element={<RequireAuth><CasinoSubscribers/></RequireAuth>} />
            <Route excat path="/all-promotions" element={<RequireAuth><PromotionNavigation/></RequireAuth>} />
            <Route exact path="/leaderboard" element={<RequireAuth><Leaderboard/></RequireAuth>} />
            <Route exact path="/affiliate-marketing" element={<RequireAuth><Affiliate/></RequireAuth>} />
            <Route exact path="/utm-report" element={<RequireAuth><UtmReport/></RequireAuth>} />
            <Route exact path="/kyc-list" element={<RequireAuth><KYCList/></RequireAuth>} />
            <Route exact path="/block-domain" element={<RequireAuth><BlockDomain/></RequireAuth>} />
            <Route exact path="/happy-hour" element={<RequireAuth><HappyHour/></RequireAuth>} />
            <Route exact path="/popup-offers" element={<RequireAuth><PopupOffers/></RequireAuth>} />
            <Route exact path="/lottery" element={<RequireAuth><Lottery/></RequireAuth>} />
            

            {/* ReferFriendDailyClaim */}
            
            
            

          </Routes>
        </div>
      </Suspense>
    </BrowserRouter>
  );
  
  function RequireAuth({ children }) {
    const User = JSON.parse(sessionStorage.getItem("user"));
    return User != null ? children : <Navigate to="/login" replace />;
  }
};

export default App;
